import { GetAdminResultsResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminResultsService {
    public async getAdminResults(assessmentId: string): Promise<GetAdminResultsResult> {
        return api.admin.getAssessmentResults(assessmentId);
    }
}

export const service = new AdminResultsService()